module.exports = __webpack_public_path__ + "img/Cecilia Young.42046501.jpg";